import * as Yup from "yup";
import { KursusholdUnderviser } from "../../../interfaces/schema";

export const kursusUndervisereForm = (
  id: string,
  kursusholdUndervisere: KursusholdUnderviser[],
  underviserId?: string,
): FormConfig<KursusUnderviserDTO> => {
  const url = `kursus/${id}/undervisere/`;
  return {
    title: "Underviser",
    lockedValues: [
      { id: "kursusId", value: id },
      { id: "kursusUnderviserId", value: underviserId },
    ],
    form: [
      {
        component: "person",
        id: "personId",
        initialValue: "",
        label: "Underviser",
        placeholder: "Søg og vælg underviser ...",
        isRequired: true,
      },
    ],
    validationSchema: Yup.object({
      personId: Yup.string()
        .test("UnderviserExists", "Underviser er allerede sat på", function () {
          return !kursusholdUndervisere
            .map((underviser) => underviser.personId)
            .includes(this.parent.personId);
        })
        .required("Vælg venligst en underviser"),
    }),
    get: url + underviserId,
    post: (values) => {
      return {
        query: url,
        body: values,
      };
    },
    delete: () => {
      return {
        query: url + underviserId,
      };
    },
  };
};
